import { useDataValue } from 'Simple/Data.js'
import assignMutation from './mutation.graphql.js'
import checkInMutation from './check-in-mutation.graphql.js'
import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

export default function useDataOnSubmit(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'check_in',
    path: 'patient_id',
  })

  let appointment_booking_id = useDataValue({
    context: 'check_in',
    path: 'appointment_booking._id',
    viewPath: props.viewPath,
  })

  let [, executeAssignMutation] = useMutation(assignMutation)
  let [, executeCheckInMutation] = useMutation(checkInMutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ args, value }) {
    let { id: connection_id } = value
    let { skip_connection_check } = args
    if ((!connection_id && !skip_connection_check) || !patient_id) return true

    if (connection_id && !skip_connection_check) {
      let mutationResponse = await executeAssignMutation({
        connection_id,
        patient_id,
      })
      if (mutationResponse.error) {
        return notify(
          notifyError(
            'An error has occurred assigning the connection to the patient'
          )
        )
      }
    }
    let mutationResponse = await executeCheckInMutation({
      id: appointment_booking_id,
      skip_connection_check,
    })
    if (mutationResponse.error) {
      return notify(notifyError('Could not check in patient'))
    }

    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
